import { NemsisCodes } from '../../../common/nemsisCodes.constants'
import { IHospitalOption } from '../../options/store/options.types'
import { PickupAddressConstants } from './pickupAddress.constants'
import { ICommonAddressesOption, IPickupAddressAction, IPickupAddressState } from './pickupAddress.types'

export const initialPickupAddressState: IPickupAddressState = {
  typeValue: null,
  typeOptions: [],
  otherType: null,
  location: '',
  county: null,
  mCD: '',
  referringMD: '',
  referringMdOther: '',
  referringRN: '',
  referringUSNG: '',
  referringGPSN: '',
  referringGPSE: '',
  RFT: '',
  responseMode: null,
  commonAddress: null,
  addressLine1: '',
  addressLine2: '',
  aptSuiteRoom: '',
  milePostMajorRoadway: '',
  crossStreetDirections: '',
  city: null,
  state: null,
  zip: '',
  country: null,
  censusTract: '',
  hospitalUnit: null,
  sceneGrid: null,
  modeDescriptors: [],
  modeDescriptorsPNNV: null,
  stateIds: null,
  __areDefaultsSet: false,
}

export const initialHospitalOption: IHospitalOption = {
  name: '',
  matchlat: '',
  matchlon: '',
  address1: '',
  address2: '',
  city: '',
  state: null,
  country: null,
  zip: '',
  county: null,
  aptSuiteRoom: '',
  stateIds: null,
  usng: '',
}

export const initialCommonAddressOption: ICommonAddressesOption = {
  id: null,
  name: '',
  address1: '',
  address2: '',
  city: '',
  state: null,
  stateIds: null,
  zip: '',
  county: null,
  aptSuiteRoom: '',
  milePostMajorRoadway: '',
  crossStreet: '',
  country: null,
  censusTract: '',
  type: null,
  mcd: '',
  usng: '',
  paFacilityName: '',
  nemsisDemographicFacType: '',
  npi: '',
  matchlat: '',
  matchlon: '',
}

export function pickupAddressReducer(
  state: IPickupAddressState = initialPickupAddressState,
  action: IPickupAddressAction
): IPickupAddressState {
  switch (action.type) {
    case PickupAddressConstants.NOT_IMPLEMENTED:
      alert('Not implemented')
      return state
    case PickupAddressConstants.SET_TYPE:
      return { ...state, typeValue: action.typeValue }
    case PickupAddressConstants.SET_TYPE_OPTIONS:
      return { ...state, typeOptions: action.typeOptions }
    case PickupAddressConstants.SET_OTHER_TYPE:
      return { ...state, otherType: action.otherType }
    case PickupAddressConstants.SET_HOSPITAL_UNIT:
      return { ...state, hospitalUnit: action.hospitalUnit }
    case PickupAddressConstants.SET_SCENE_GRID:
      return { ...state, sceneGrid: action.sceneGrid }
    case PickupAddressConstants.SET_MODE_DESCRIPTORS:
      return { ...state, modeDescriptors: action.modeDescriptors }
    case PickupAddressConstants.SET_PICKUP_ADDRESS_MODE_DESCRIPTORS_PNNV:
      return { ...state, modeDescriptorsPNNV: action.modeDescriptorsPNNV }
    case PickupAddressConstants.SET_LOCATION:
      return { ...state, location: action.location }
    case PickupAddressConstants.SET_COMMON_ADDRESS:
      return { ...state, commonAddress: action.commonAddress }
    case PickupAddressConstants.SET_ADDRESS_LINE1:
      return { ...state, addressLine1: action.addressLine1 }
    case PickupAddressConstants.SET_ADDRESS_LINE2:
      return { ...state, addressLine2: action.addressLine2 }
    case PickupAddressConstants.SET_APT_SUITE_ROOM:
      return { ...state, aptSuiteRoom: action.aptSuiteRoom }
    case PickupAddressConstants.SET_MILE_POST_MAJOR_ROADWAY:
      return { ...state, milePostMajorRoadway: action.milePostMajorRoadway }
    case PickupAddressConstants.SET_CROSS_STREET_DIRECTIONS:
      return { ...state, crossStreetDirections: action.crossStreetDirections }
    case PickupAddressConstants.SET_CITY:
      return { ...state, city: action.city }
    case PickupAddressConstants.SET_STATE:
      return { ...state, state: action.state }
    case PickupAddressConstants.SET_ZIP:
      return { ...state, zip: action.zip }
    case PickupAddressConstants.SET_COUNTRY:
      return { ...state, country: action.country }
    case PickupAddressConstants.SET_CENSUS_TRACT:
      return { ...state, censusTract: action.censusTract }
    case PickupAddressConstants.SET_COUNTY:
      return { ...state, county: action.county }
    case PickupAddressConstants.SET_MCD:
      return { ...state, mCD: action.mCD }
    case PickupAddressConstants.SET_REFERRING_MD:
      return { ...state, referringMD: action.referringMD }
    case PickupAddressConstants.SET_REFERRING_MD_OTHER:
      return { ...state, referringMdOther: action.referringMdOther }
    case PickupAddressConstants.SET_REFERRING_RN:
      return { ...state, referringRN: action.referringRN }
    case PickupAddressConstants.SET_REFERRING_USNG:
      return { ...state, referringUSNG: action.referringUSNG }
    case PickupAddressConstants.SET_REFERRING_GPS_N:
      return { ...state, referringGPSN: action.referringGPSN }
    case PickupAddressConstants.SET_REFERRING_GPS_E:
      return { ...state, referringGPSE: action.referringGPSE }
    case PickupAddressConstants.SET_RFT:
      return { ...state, RFT: action.RFT }
    case PickupAddressConstants.SET_STATE_IDS:
      return { ...state, stateIds: action.stateIds }
    case PickupAddressConstants.SET_RESPONSE_MODE:
      return { ...state, responseMode: action.responseMode }
    case PickupAddressConstants.SET_PICKUP_ADDRESS_DEFAULTS:
      return { ...state, __areDefaultsSet: action.__areDefaultsSet }
    case PickupAddressConstants.SET_PICKUP_ADDRESS_STATE:
      return { ...state, ...action.pickupAddress }
    case PickupAddressConstants.RESET_PICKUP_ADDRESS_STATE:
      return { ...initialPickupAddressState }
    case PickupAddressConstants.SET_DEFAULT_HOSPITAL_CODE:
      return { ...state, otherType: { nemsisCodeRef: NemsisCodes.PICKUP_DEFAULT_HOSPITAL_CODE as string } }
    case PickupAddressConstants.SET_DEFAULT_EMS_CODE:
      return { ...state, otherType: { nemsisCodeRef: NemsisCodes.PICKUP_DEFAULT_EMS_CODE as string } }
    case PickupAddressConstants.SET_PICKUP_ADDRESS_DEFAULTS_WITH_RESPONSE_MODE:
      return { ...state, responseMode: action.responseMode }
    default:
      return state
  }
}
